import axios from "axios";
import { Loading, Notify } from "notiflix";
import { APIURL } from "./config";
import { CERTIFICATE_KID_LIST, CERTIFICATE_LIST, CLASS_LIST, SEARCH_KID_LIST, SECTION_LIST, STUDENT_LIST } from "./types";

export const getStudentList = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/entity/school-dashboard/kid-management/kid-status-list`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: STUDENT_LIST, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({
            type: STUDENT_LIST,
            payload: {},
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const updateStudent = (data, cb) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/entity/school-dashboard/kid-management/edit/kid-details`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Updated successfully!"
         Notify.success(message);
         if (cb) cb();
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const getCertificates = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/certificate`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: CERTIFICATE_LIST, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({
            type: CERTIFICATE_LIST,
            payload: {},
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const managementKidList = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/entity/school-dashboard/kid-management/kid-list`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: SEARCH_KID_LIST, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({
            type: SEARCH_KID_LIST,
            payload: {},
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const getCertificateKidList = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/certificate/kids`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: CERTIFICATE_KID_LIST, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({
            type: CERTIFICATE_KID_LIST,
            payload: {},
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const getClassList = () => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/classes`, {}, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: CLASS_LIST, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({ type: CLASS_LIST, payload: [] });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const getSectionList = () => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/sections`, {}, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: SECTION_LIST, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({ type: SECTION_LIST, payload: [] });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}